import React, { MouseEvent, useState } from 'react';
import { Menu } from '@mui/material';
import styles from '../elements/layout/context-menu/ContextMenu.styles';

interface ContextMenuState {
    x: number | null;
    y: number | null;
}

const initialState: ContextMenuState = {
    x: null,
    y: null,
};

export default function useContextMenu(children: (handleClose: () => void) => Array<React.ReactNode>) {
    const [state, setState] = useState(initialState);

    const handleOpen = (event: MouseEvent) => {
        event.preventDefault();
        setState({
            x: event.clientX - 2,
            y: event.clientY - 4,
        });
    };

    const handleClose = () => {
        setState(initialState);
    };

    const contextMenu = <UseContextMenu children={children} state={state} handleClose={handleClose} />;

    return {
        handleOpen,
        handleClose,
        contextMenu,
    };
}

function UseContextMenu({
    children,
    state,
    handleClose,
}: {
    children: (handleClose: () => void) => Array<React.ReactNode>;
    state: ContextMenuState;
    handleClose: () => void;
}) {
    return (
        <Menu
            keepMounted
            open={state.y !== null}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={state.x !== null && state.y !== null ? { top: state.y, left: state.x } : undefined}
            sx={styles.menu}
        >
            {children(handleClose)}
        </Menu>
    );
}
